import React, { useRef } from 'react';

import { AppState } from '../../types/game';
import { Product } from '../../hooks/useProducts';
import { useAppSelector } from '../../store/hooks';
import { selectIsProductConfirmationMode, selectIsProductConfirmed } from '../../store/selectors';
import { useGameCompletion } from '../../hooks/statusbar/useGameCompletion';

import DefaultGameBar from './DefaultGameBar';
import ProductConfirmationBar from './ProductConfirmationBar';
import OfferConfirmedBar from './OfferConfirmedBar';
import './StatusBar.css';

export interface StatusBarProps {
  walletAmount: number;
  claimedPrizes: number;
  totalPrizes: number;
  showPrizeAnimation: boolean;
  walletPulse: boolean;
  walletRef: React.RefObject<HTMLDivElement>;
  selectedProduct: Product | null;
  showDiscountApplied: boolean;
  timeRemaining: number;
  appState: AppState;
  setAppState: (state: AppState) => void;
  onLoadFeed?: () => void;
  feedLoaded?: boolean;
  rootPath?: string;
  itemCount: number;
}

const StatusBar = (props: StatusBarProps) => {
  const { walletAmount, timeRemaining, onLoadFeed, feedLoaded = false } = props;
  const statusBarRef = useRef<HTMLDivElement>(null);

  const isProductConfirmationMode = useAppSelector(selectIsProductConfirmationMode);
  const isProductConfirmed = useAppSelector(selectIsProductConfirmed);

  useGameCompletion(timeRemaining, walletAmount);

  const handleStatusBarClick = () => {
    if (!feedLoaded && onLoadFeed && !isProductConfirmationMode) {
      onLoadFeed();
    }
  };

  const renderContent = () => {
    if (isProductConfirmationMode) {
      if (isProductConfirmed) {
        return <OfferConfirmedBar />;
      }
      return <ProductConfirmationBar {...props} />;
    }
    return <DefaultGameBar {...props} />;
  };

  return (
    <div
      ref={statusBarRef}
      className={`playmerce-game-statusbar ${!feedLoaded && !isProductConfirmationMode ? 'clickable' : ''}`}
      onClick={handleStatusBarClick}
    >
      {renderContent()}
    </div>
  );
};

export default StatusBar;
